export enum AuthenticationResultEnum {
	UnexpectedError = 0,
	Success = 1,
    InvalidUser = 2,
    InvalidPassword = 3,
    AccountLocked = 4,
	PasswordChangeRequired = 5,
	PasswordExpired = 6,
    DisabledForCustomer = 7,
    NoPermissionsForCustomer = 8,
    SSONotEnabled = 9,
    SSOUserNotFound = 10,
    TokenIDUserNotFound = 11,
    LoginFailed = 13,
    TokenExpired = 100
}
